import { Button } from '@library/components/buttons';
import addIcon from '@library/assets/images/icons/add-icon.svg';
import { classNames } from '@library/utils';

export interface ShowProjectionsModalButtonProps {
  className?: string;
  disabled?: boolean;
  onClick: () => void;
}

export const ShowProjectionsModalButton = ({
  className = '',
  disabled = false,
  onClick
}: ShowProjectionsModalButtonProps) => {
  return (
    <Button
      className={classNames(className, 'w-6 disabled:cursor-not-allowed')}
      data-testid="ShowProjectionsModalButton"
      disabled={disabled}
      title="ShowProjectionsModalButton"
      onClick={onClick}
      type="button"
    >
      <img alt="add icon" className="h-6" src={addIcon} />
    </Button>
  );
};
